import React from "react";
import styled from "styled-components";

import { StyledPrimaryText, StyledSecondaryText } from "./Styled";
import { PrimaryTextProps, SecondaryTextProps } from "./types";

export type { PrimaryTextProps, SecondaryTextProps };

const PrimaryTextWrapper = React.forwardRef<HTMLElement, PrimaryTextProps>(
    (
        {
            fontSize,
            fontWeight,
            lineHeight,
            textAlign,
            padding,
            margin,
            textNoWrap,
            textColor,
            inline,
            as,
            ...rest
        },
        ref,
    ) => {
        return (
            <StyledPrimaryText
                ref={ref}
                as={as}
                $fontSize={fontSize}
                $fontWeight={fontWeight}
                $lineHeight={lineHeight}
                $textAlign={textAlign}
                $padding={padding}
                $margin={margin}
                $textNoWrap={textNoWrap}
                $textColor={textColor}
                $inline={inline}
                {...rest}
            />
        );
    },
);
PrimaryTextWrapper.displayName = "PrimaryTextWrapper";

export const PrimaryText = styled(PrimaryTextWrapper)``;

const SecondaryTextWrapper = React.forwardRef<HTMLElement, SecondaryTextProps>(
    (
        {
            fontSize,
            fontWeight,
            lightTheme,
            lineHeight,
            textAlign,
            padding,
            margin,
            textNoWrap,
            as,
            ...rest
        },
        ref,
    ) => {
        return (
            <StyledSecondaryText
                ref={ref}
                as={as}
                $fontSize={fontSize}
                $fontWeight={fontWeight}
                $lightTheme={lightTheme}
                $lineHeight={lineHeight}
                $textAlign={textAlign}
                $padding={padding}
                $margin={margin}
                $textNoWrap={textNoWrap}
                {...rest}
            />
        );
    },
);
SecondaryTextWrapper.displayName = "SecondaryTextWrapper";

export const SecondaryText = styled(SecondaryTextWrapper)``;
